'use client'

import {type ArticlePromoNewsletterRecord} from '~/_generated/graphql'
import {getBlogNewsletterProps} from '~/cms/helpers/getBlogNewsletterProps'
import {HgPromoEmailCapture} from '~/design-system/hg/modules'

type PromoEmailCaptureClientProps = ArticlePromoNewsletterRecord & {
  width: 'inset' | 'fullWidth'
}

export const PromoEmailCaptureClient = (props: PromoEmailCaptureClientProps) => {
  const {width, ...rest} = props

  return <HgPromoEmailCapture width={width} {...getBlogNewsletterProps(rest)} />
}
